import React, {useEffect, useState} from 'react'
import { BrowserRouter, Route, Switch } from "react-router-dom";
import './styles/index.scss';
import LoginContainer from "./components/login/LoginContainer";
import Page404 from "./components/page404/Page404";
import LogBook from "./components/main/logbook/LogBook";
import ProfileContainer from "./components/main/Profile/ProfileContainer";
import {connect, Provider} from "react-redux";
import store from "./redux/store";
import {setRecoveryToken, setToken} from "./redux/auth/auth-actions";
import instance from "./redux/instance";
import {getUser} from "./redux/user/user-thunks";
import Shared from "./components/main/Shared/Shared";

import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import {en} from "./translations/en";
import {ru} from "./translations/ru";
import {getNotifications} from "./redux/notifications/notifications-thunks";

String.prototype.toBoolean = function() {
  return String(this.valueOf()).toLowerCase() === true.toString();
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: en
      },
      ru: {
        translation: ru
      }
    },
    lng: "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false
    }
  });

export const useTheme = () => {
  const [isDark, setIsDark] = useState(JSON.parse(localStorage.getItem('isDark')))
  const setTheme = (isDark) => {
    localStorage.setItem('isDark', isDark)
    setIsDark(isDark)
  }
  return {
    isDark, setTheme,
  }
}

let App = ({setToken, token, getUser, ...props}) => {
  const {isDark, setTheme} = useTheme()
  const {t} = useTranslation()
  useEffect(() => {
    //localStorage.removeItem('token')
    // todo old auth
    setToken(localStorage.getItem('token'))
    if(localStorage.getItem('token') !== null) {
      Object.assign(instance.defaults, {headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}});
    }
    // setToken(localStorage.getItem('token') !== null)
    if(localStorage.getItem('lang')) {
      i18n.changeLanguage(localStorage.getItem('lang'))
    }
    // todo old auth
    // if (localStorage.getItem('token') === false)
    if(localStorage.getItem('token') === null && window.location.href.split('?token=').length === 2) {
      props.setRecoveryToken(window.location.href.split('?token=')[1])
    }
  }, [])
  useEffect(() => {
    if(token) {
      // todo old auth
      Object.assign(instance.defaults, {headers: {Authorization: `Bearer ${token}`}});
      getUser()
      props.getNotifications()
    }
  }, [token])
  return (
    <BrowserRouter>
      <div className={`app ${isDark && 'app__dark'}`}>
        <Switch>
          <Route exact path={'/logbook'} render={() => <LogBook isDark={isDark} setTheme={() => setTheme(!isDark)} />} />
          <Route path={'/logbook/profile'} render={() => <ProfileContainer isDark={isDark} setTheme={() => setTheme(!isDark)} />} />
          <Route path={'/logbook/share'} render={() => <Shared isDark={isDark} />} />
          <Route path={'/logbook/auth'} render={() => <LoginContainer />} />
          <Route path={'/'} render={() => <Page404 />} />
          <Route render={() => <Page404 />} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

const mapStateToProps = (state) => ({
  token: state.authReducer.token
})

App = connect(mapStateToProps, {setToken, getUser, getNotifications, setRecoveryToken})(App)

const AppWrapper = () => {
  return <Provider store={store}>
    <App />
  </Provider>
}

export default React.memo(AppWrapper);
